import { Observable } from "rxjs";

export abstract class DataServiceInterface {
    abstract get(): Observable<any>;
    abstract add(data: any): Observable<any>;
}